export default {
  // The blog's title as it appears in the layout header, and in the document
  // <title> tag.
  title: "Artificial Unintelligence.",

  author: "Miles Garnsey",
  description: "A blog about data science and engineering, machine learning, and distributed system engineering.",

  // The number of posts to a page on the site index.
  indexPageSize: 10,
}
